import { HrpsApiClient } from '../../clients/HrpsApiClient';
import { CarriersMap } from '../types';
import {
    CARRIERS_LOAD_START,
    CARRIERS_LOAD_SUCCESS,
    CARRIERS_LOAD_FAILURE,
    CarriersLoadStartAction,
    CarriersLoadSuccessAction,
    CarriersLoadFailureAction,
} from './carriersActions';

export const carriersLoadStart = (): CarriersLoadStartAction => ({
    type: CARRIERS_LOAD_START,
});

export const carriersLoadSuccess = (carriers: CarriersMap): CarriersLoadSuccessAction => ({
    type: CARRIERS_LOAD_SUCCESS,
    payload: carriers,
});

export const carriersLoadFailure = (error: string): CarriersLoadFailureAction => ({
    type: CARRIERS_LOAD_FAILURE,
    payload: error,
});

export const loadCarriers = () => async (dispatch: any) => {
    dispatch(carriersLoadStart());
    try {
        const client = new HrpsApiClient();
        const carriers = await client.getCarriersMap();
        dispatch(carriersLoadSuccess(carriers));
    } catch (error) {
        dispatch(carriersLoadFailure(error instanceof Error ? error.message : 'Failed to load carriers'));
    }
};
